import { render, staticRenderFns } from "./MenuReportCommission.vue?vue&type=template&id=541c1979&scoped=true&"
import script from "./MenuReportCommission.vue?vue&type=script&lang=js&"
export * from "./MenuReportCommission.vue?vue&type=script&lang=js&"
import style0 from "./MenuReportCommission.vue?vue&type=style&index=0&id=541c1979&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541c1979",
  null
  
)

export default component.exports